<template>
  <div class="nologin">
    <div class="nologin_notfound">
      <!-- メッセージ-->
      <div class="message_error" data-test="message">
        {{ $t('error.notfound.message') }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/assets/sass/nologin/404.scss' as nologin;
@use '@/assets/sass/parts/messageError.scss';

.nologin {
  &_notfound {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
}
</style>

<script setup lang="ts"></script>
